import { lazy } from "react";
import { Icon } from "@mui/material";

const routes = [
  // { type: "title", title: "Dashboards", key: "dashboad-pages", roles: ["admin", "operator"] },
  {
    type: "none",
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    component: lazy(() => import("pages/dashboard")),
    noCollapse: true,
    protected: true,
    roles: ["admin", "operator"],
  },
  {
    type: "none",
    key: "/monitoring/:id",
    route: "/monitoring/:id",
    icon: <Icon fontSize="small">bar_chart</Icon>,
    component: lazy(() => import("pages/monitoring")),
    noCollapse: true,
    protected: true,
    roles: ["admin", "operator"],
  },
  {
    type: "title",
    title: "Reports",
    key: "report-pages",
    roles: ["admin", "operator"],
  },
  {
    type: "collapse",
    name: "History",
    key: "history",
    route: "/history",
    icon: <Icon fontSize="small">history</Icon>,
    component: lazy(() => import("pages/reports")),
    noCollapse: true,
    protected: true,
    roles: ["admin", "operator"],
  },
  {
    type: "collapse",
    name: "Records",
    key: "records",
    route: "/records",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    component: lazy(() => import("pages/gauge")),
    noCollapse: true,
    protected: true,
    roles: ["admin", "operator"],
  },
  {
    type: "collapse",
    name: "Alarm Manager",
    key: "alert-reports",
    route: "/alert-reports",
    icon: <Icon fontSize="small">notification_important</Icon>,
    component: lazy(() => import("pages/alertReports")),
    noCollapse: true,
    protected: true,
    roles: ["admin", "operator"],
  },
  // {
  //   type: "title",
  //   title: "Monitorings & Widgets",
  //   key: "dashboad-mangement-pages",
  //   roles: ["admin", "operator"],
  // },
  // {
  //   type: "none",
  //   name: "Widgets",
  //   key: "widgets",
  //   route: "/widgets",
  //   icon: <Icon fontSize="small">widgets</Icon>,
  //   component: lazy(() => import("pages/widgets")),
  //   noCollapse: true,
  //   protected: true,
  //   roles: ["admin", "operator"],
  // },
  {
    type: "none",
    key: "monitorings",
    route: "/monitorings/:monitoringId/widgets/:id/detail",
    component: lazy(() => import("pages/widgets/detail")),
    noCollapse: true,
    protected: true,
    roles: ["admin", "operator"],
  },
  { type: "title", title: "Settings", key: "setting-pages", roles: ["admin", "operator"] },
  {
    type: "collapse",
    name: "Connections",
    key: "connections",
    route: "/connections",
    icon: <Icon fontSize="small">settings_input_component</Icon>,
    component: lazy(() => import("pages/connections")),
    noCollapse: true,
    protected: true,
    roles: ["admin", "operator"],
  },
  {
    type: "npne",
    key: "connections",
    route: "/connections/create",
    component: lazy(() => import("pages/connections/create")),
    noCollapse: true,
    protected: true,
    roles: ["admin"],
  },
  {
    type: "npne",
    key: "connections",
    route: "/connections/:id/detail",
    component: lazy(() => import("pages/connections/detail")),
    noCollapse: true,
    protected: true,
    roles: ["admin", "operator"],
  },
  {
    type: "npne",
    key: "connections",
    route: "/connections/:id/update",
    component: lazy(() => import("pages/connections/update")),
    noCollapse: true,
    protected: true,
    roles: ["admin"],
  },
  {
    type: "collapse",
    name: "Tag Groups",
    key: "tag-groups",
    route: "/tag-groups",
    icon: <Icon fontSize="small">style</Icon>,
    component: lazy(() => import("pages/tagGroups")),
    noCollapse: true,
    protected: true,
    roles: ["admin", "operator"],
  },
  {
    type: "none",
    key: "tag-groups",
    route: "/tag-groups/:id/detail",
    component: lazy(() => import("pages/tagGroups/detail")),
    noCollapse: true,
    protected: true,
    roles: ["admin", "operator"],
  },
  {
    type: "collapse",
    name: "Alarms",
    key: "alerts",
    route: "/alerts",
    icon: <Icon fontSize="small">notifications_active</Icon>,
    component: lazy(() => import("pages/alerts")),
    noCollapse: true,
    protected: true,
    roles: ["admin", "operator"],
  },
  {
    type: "none",
    key: "alerts",
    route: "/alerts/tags/:id/detail",
    component: lazy(() => import("pages/alerts/tagDetail")),
    noCollapse: true,
    protected: true,
    roles: ["admin", "operator"],
  },
  {
    type: "none",
    key: "alerts",
    route: "/alerts/:id/detail",
    component: lazy(() => import("pages/alerts/detail")),
    noCollapse: true,
    protected: true,
    roles: ["admin", "operator"],
  },
  {
    type: "collapse",
    name: "Monitorings",
    key: "monitorings",
    route: "/monitorings",
    icon: <Icon fontSize="small">dashboard_customize</Icon>,
    component: lazy(() => import("pages/monitorings&DisplayProfiles")),
    noCollapse: true,
    protected: true,
    roles: ["admin", "operator"],
  },
  {
    type: "none",
    key: "monitorings",
    route: "/monitorings/create",
    component: lazy(() => import("pages/monitorings/create")),
    noCollapse: true,
    protected: true,
    roles: ["admin"],
  },
  {
    type: "none",
    key: "monitorings",
    route: "/monitorings/:id/detail",
    component: lazy(() => import("pages/monitorings/detail")),
    noCollapse: true,
    protected: true,
    roles: ["admin", "operator"],
  },
  {
    type: "none",
    key: "monitorings",
    route: "/monitorings/:id/update",
    component: lazy(() => import("pages/monitorings/update")),
    noCollapse: true,
    protected: true,
    roles: ["admin"],
  },
  // { type: "title", title: "Accounts", key: "account-pages", roles: ["admin"] },
  {
    type: "collapse",
    name: "Accounts",
    key: "accounts",
    route: "/accounts",
    icon: <Icon fontSize="small">people</Icon>,
    component: lazy(() => import("pages/users")),
    noCollapse: true,
    protected: true,
    roles: ["admin", "operator"],
  },
  {
    type: "none",
    key: "accounts",
    route: "/accounts/create",
    component: lazy(() => import("pages/users/create")),
    noCollapse: true,
    protected: true,
    roles: ["admin"],
  },
  {
    type: "none",
    key: "accounts",
    route: "/accounts/:id/update",
    component: lazy(() => import("pages/users/update")),
    noCollapse: true,
    protected: true,
    roles: ["admin"],
  },
  {
    type: "none",
    key: "accounts",
    route: "/accounts/:id/detail",
    component: lazy(() => import("pages/users/detail")),
    noCollapse: true,
    protected: true,
    roles: ["admin", "operator"],
  },
  {
    type: "collapse",
    name: "System",
    key: "system",
    route: "/system",
    icon: <Icon fontSize="small">settings</Icon>,
    component: lazy(() => import("pages/setting")),
    noCollapse: true,
    protected: true,
    roles: ["admin", "operator"],
  },
  {
    type: "collapse",
    name: "Manual",
    key: "manual",
    route: "/manual",
    icon: <Icon fontSize="small">menu_book</Icon>,
    component: lazy(() => import("pages/manual")),
    noCollapse: true,
    protected: true,
    roles: ["admin", "operator"],
  },
  // {
  //   type: "collapse",
  //   name: "Profile",
  //   key: "profile",
  //   route: "/profile",
  //   icon: <Icon fontSize="small">person</Icon>,
  //   component: lazy(() => import("pages/profile")),
  //   noCollapse: true,
  //   protected: true,
  //   roles: ["admin", "operator"],
  // },
  {
    type: "none",
    name: "Sign In",
    key: "login",
    route: "/login",
    component: lazy(() => import("pages/accounts/sign-in")),
    noCollapse: true,
  },
  {
    type: "none",
    key: "404",
    route: "/404",
    component: lazy(() => import("pages/NotFound")),
    noCollapse: true,
  },
];

export default routes;
